import { akedlyInboxQueryKeys as e } from "./akedlyInboxQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/useAkedlyInboxQuery.ts
var r = (r = {}) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.listInbox({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useAkedlyInboxQuery };
